export const ICONS = {
	LOADING: 'https://storage.googleapis.com/tirx-resources-production/fd827b1d-2c80-4428-98ad-ccf98e4c72a1.gif',
	WELCOME: 'https://storage.googleapis.com/tirx-resources-production/392c51fe-fe05-4d5d-97f0-f064e6489755.webp',
};
